import { RestAPI } from './rest-api.service';
import { BASE_URL } from '../types/constants';
import { HomePromo } from '../types/home.types';

const api = new RestAPI();

/**
 * Public promos feed.
 * Endpoint: GET /v1/promos
 */
export const fetchPromos = async (): Promise<HomePromo[]> => {
    const url = `${BASE_URL}/v1/promos`;
    return api.get(url);
};
